import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { initSendbirdInstance } from 'utils/sendbird'
import { useConnectStatus } from 'components/pagesContent/Chat/customHooks/useConnectStatus'
import { getClientSettings } from 'reduxBits/chat/actions'
import UnreadMessages from './UnreadMessages'

/*
  This component is made to connect the user to sendbird at root level,
  to avoid multiple sendbird instances and the need for 'message-center-count' plugin.
*/
const SendbirdConnector = () => {
  const appId = useSelector((state) => state.config.chatAppID)
  const connected = useConnectStatus(initSendbirdInstance(appId))
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getClientSettings())
  }, [dispatch])

  if (!connected) {
    return null
  }

  return <UnreadMessages />
}

export default SendbirdConnector
